import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage.tsx';
import {useVerifiedPermissions} from '../../hooks/useVerifiedPermissions.ts';
import {rbacActions} from '../../config/rbac/actions.ts';

export const TestDefinitionsLayout = () => {

    const {allowedActions} = useVerifiedPermissions();

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListTestDefinitions) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/dashboard'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes(rbacActions.CreateTestDefinition) ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/dashboard'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetTestDefinition) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/dashboard'/>
                    )
                }
            />
        </Routes>
    );
};
